import axios from "axios";
const API_URL = process.env.REACT_APP_API_URL;

/** ✅ Crear una nueva maleta */
export const createMaleta = async ({ nombre, usuarioId, fechaCreacion }) => {
  const token = localStorage.getItem("token");
  try {
    const response = await axios.post(
      `${API_URL}/api/maletas`,
      { nombre, usuarioId, fechaCreacion },
      { headers: { Authorization: `Bearer ${token}` } },
    );
    return response.data;
  } catch (error) {
    console.error("❌ Error al crear maleta:", error);
    throw error;
  }
};

/** ✅ Agregar muestra a una maleta */
export const addMuestraToMaleta = async (maletaId, muestraId) => {
  const token = localStorage.getItem("token");
  try {
    const response = await axios.post(
      `${API_URL}/api/maletas/${maletaId}/muestras`,
      { muestraId },
      { headers: { Authorization: `Bearer ${token}` } },
    );
    return response.data;
  } catch (error) {
    console.error("❌ Error al agregar muestra a la maleta:", error);
    throw error;
  }
};

/** ✅ Registrar el movimiento en MuestrasUbicacion */
export const addMuestraToUbicacion = async ({
  muestraId,
  maletaId,
  ubicacion,
  fecha,
  marcaId,
}) => {
  const token = localStorage.getItem("token");
  try {
    await axios.post(
      `${API_URL}/api/movimientosMuestras/ubicacion`, // ✅ Correcto
      { muestraId, maletaId, ubicacion, fecha, marcaId }, // ✅ Incluye marcaId
      { headers: { Authorization: `Bearer ${token}` } },
    );
  } catch (error) {
    console.error(
      "❌ Error al registrar movimiento en MuestrasUbicacion:",
      error,
    );
    throw error;
  }
};

export const updateMuestraUbicacion = async (
  maletaId,
  muestraId,
  ubicacion,
) => {
  const token = localStorage.getItem("token");
  try {
    await axios.patch(
      `${API_URL}/api/maletas/${maletaId}/muestras/${muestraId}`,
      { ubicacion },
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );
  } catch (error) {
    console.error("❌ Error en uploadDocumentoFabrica:", error);
    throw error;
  }
};

export const getMaletasByUsuario = async (usuarioId) => {
  const token = localStorage.getItem("token");
  const response = await axios.get(
    `${API_URL}/api/maletas/usuario/${usuarioId}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    },
  );
  return response.data;
};

export const getMaletasTree = async () => {
  const token = localStorage.getItem("token"); // 🔹 Recuperar token del almacenamiento
  if (!token) {
    throw new Error("Token no encontrado, por favor inicia sesión");
  }

  try {
    const response = await axios.get(`${API_URL}/api/maletas/tree`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.error("❌ Error en getMaletasTree:", error.response?.data || error);
    throw error;
  }
};

/** ✅ Obtener todas las maletas */
export const getAllMaletas = async () => {
  const token = localStorage.getItem("token");
  try {
    const response = await axios.get(`${API_URL}/api/maletas`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.error("❌ Error al obtener maletas:", error);
    throw error;
  }
};

/** ✅ Obtener muestras dentro de una maleta */
export const getMuestrasDeMaleta = async (maletaId) => {
  const token = localStorage.getItem("token");
  try {
    const response = await axios.get(
      `${API_URL}/api/maletas/${maletaId}/muestras`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );
    return response.data;
  } catch (error) {
    console.error("❌ Error al obtener muestras de la maleta:", error);
    throw error;
  }
};

/** ✅ Quitar muestra de una maleta */
/** ✅ Quitar muestra de una maleta y sus movimientos */
export const removeMuestraFromMaleta = async (maletaId, muestraId) => {
  const token = localStorage.getItem("token");

  if (!maletaId || !muestraId) {
    console.error("❌ Error: Parámetros inválidos en removeMuestraFromMaleta", {
      maletaId,
      muestraId,
    });
    throw new Error("Parámetros inválidos");
  }

  try {
    const response = await axios.delete(
      `${API_URL}/api/maletas/${maletaId}/muestras/${muestraId}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return response.data;
  } catch (error) {
    console.error("❌ Error al quitar muestra de la maleta:", error);
    throw error;
  }
};

/** ✅ Descargar informe en PDF */
export const downloadMaletaInforme = async (maletaId) => {
  const token = localStorage.getItem("token");
  try {
    const response = await axios.get(
      `${API_URL}/api/maletas/${maletaId}/informe`,
      {
        headers: { Authorization: `Bearer ${token}` },
        responseType: "blob",
      },
    );

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `Informe_Maleta_${maletaId}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (error) {
    console.error("❌ Error al descargar informe PDF:", error);
    throw error;
  }
};

/** ✅ Obtener muestras que aún no están asignadas a una maleta */
export const getMuestrasDisponibles = async () => {
  const token = localStorage.getItem("token");
  try {
    const response = await axios.get(`${API_URL}/api/muestras/disponibles`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.error("❌ Error al obtener muestras disponibles:", error);
    throw error;
  }
};

/** ✅ Asignar muestra a una maleta */
export const asignarMuestraAMaleta = async (maletaId, muestraId) => {
  const token = localStorage.getItem("token");
  try {
    const response = await axios.post(
      `${API_URL}/api/maletas/${maletaId}/asignar-muestra`,
      { muestraId },
      { headers: { Authorization: `Bearer ${token}` } },
    );
    return response.data;
  } catch (error) {
    console.error("❌ Error al asignar muestra a maleta:", error);
    throw error;
  }
};

/** ✅ Obtener detalles de una maleta por ID */
export const getMaletaById = async (maletaId) => {
  const token = localStorage.getItem("token");
  try {
    const response = await axios.get(`${API_URL}/api/maletas/${maletaId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.error("❌ Error al obtener maleta por ID:", error);
    throw error;
  }
};

/** ✅ Obtener muestras dentro de una maleta */
export const getMuestrasInMaleta = async (maletaId) => {
  const token = localStorage.getItem("token");
  try {
    const response = await axios.get(
      `${API_URL}/api/maletas/${maletaId}/muestras`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );
    return response.data;
  } catch (error) {
    console.error("❌ Error al obtener muestras en la maleta:", error);
    throw error;
  }
};

export const agregarMuestra = async (data) => {
  const token = localStorage.getItem("token");
  const response = await axios.post(
    `${API_URL}/api/movimientosMuestras/ubicacion`,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return response.data;
};
